import { categoryByIdSelector } from "./categoryByIdSelector";
import { RootState } from "../../store";

export const categoryNameByCategoryIdSelector = (
  state: RootState,
  categoryId: string,
): string | undefined => {
  return categoryByIdSelector({ categoryId })(state)?.data?.value;
};
